import React from "react";
import { daysInMonth } from "./utils";

const CalendarGrid = ({ currentMonth, selectedDate, setSelectedDate }) => {
    const weekDays = ["L", "M", "X", "J", "V", "S", "D"];

    const renderDays = () => {
        const days = [];
        const startDay =
            (new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth(),
                1
            ).getDay() +
                6) %
            7;
        const totalDays = daysInMonth(
            currentMonth.getMonth(),
            currentMonth.getFullYear()
        );

        for (let i = 0; i < startDay; i++) {
            days.push(<div key={`empty-${i}`} className="day empty" />);
        }

        for (let day = 1; day <= totalDays; day++) {
            const date = new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth(),
                day
            );
            days.push(
                <div
                    key={day}
                    className={`day ${
                        date.toDateString() === selectedDate.toDateString()
                            ? "selected"
                            : ""
                    }`}
                    onClick={() => setSelectedDate(date)}
                >
                    {day}
                </div>
            );
        }
        return days;
    };

    return (
        <div className="calendar-grid">
            {weekDays.map((day, index) => (
                <div key={index} className="day-header">
                    {day}
                </div>
            ))}
            {renderDays()}
        </div>
    );
};

export default CalendarGrid;
